import { memo } from 'react';
import { Card, Badge } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

const STUDIOS = ['governance', 'agentic', 'workforce'];

// Prototype left-accent per studio; enabled tiles are tinted, the rest stay muted.
const ACCENT = {
  governance: 'border-l-2 border-l-emerald-500/70',
  agentic: 'border-l-2 border-l-purple-500/70',
  workforce: 'border-l-2 border-l-edge',
};

/**
 * "Used in studios" panel (CT-4179): one tile per studio (Governance / Agentic /
 * Workforce) showing Enabled / Not enabled, the usage metric, and an optional
 * secondary detail line when enabled. Enabled tiles carry a colored left accent.
 */
function UsedInStudiosPanel({ studios = {} }) {
  const { t } = useTranslation('admin-studio');
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
      {STUDIOS.map((key) => {
        const s = studios[key] ?? { enabled: false };
        return (
          <Card key={key} className={s.enabled ? ACCENT[key] : ACCENT.workforce}>
            <Card.Body>
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-medium text-content">
                  {t(`integrations.provider.overview.studios.${key}`)}
                </span>
                <Badge variant={s.enabled ? 'success' : 'neutral'} size="small" radius="full">
                  {t(
                    s.enabled
                      ? 'integrations.provider.overview.enabled'
                      : 'integrations.provider.overview.notEnabled',
                  )}
                </Badge>
              </div>
              {s.enabled && s.usage && (
                <p className="mt-1 text-xs text-content-muted">{s.usage}</p>
              )}
              {s.enabled && s.detail && (
                <p className="text-[11px] text-content-faint">{s.detail}</p>
              )}
            </Card.Body>
          </Card>
        );
      })}
    </div>
  );
}

export default memo(UsedInStudiosPanel);
